import LoyaltyRewardsSFC from "./LoyaltyRewards.vue";
export const LoyaltyRewards = LoyaltyRewardsSFC;
